export default "__VITE_ASSET__CBq_8FAU__"